import { highlightForumText, sanitizeForumHtml } from '@/features/forum-next/models/forumContent';

// The classic search uses v-html for highlighting. Construct only escaped text
// plus our own span; never run a regex across user HTML or attributes.
export function legacySearchHighlight(value, query, { html = false, exact = false } = {}) {
  let text = typeof value === 'string' ? value : '';
  if (html) {
    const fragment = document.createElement('template');
    fragment.innerHTML = sanitizeForumHtml(text);
    text = fragment.content.textContent || '';
  }
  const escape = value => value.replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  // Exact mode is a single phrase, including literal quotation marks.
  let segments;
  if (exact && query) {
    const expression = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    segments = text.split(expression).map((part, index) => ({ text: part, match: index % 2 === 1 }));
  } else segments = highlightForumText(text, query);
  return segments.map(part => part.match ? '<span class="highlight">' + escape(part.text) + '</span>' : escape(part.text)).join('');
}
